// extracted by mini-css-extract-plugin
export default {"scroll":"ScrollButton_scroll__5-cxZ","line":"ScrollButton_line__nHYND","arrowsDown":"ScrollButton_arrowsDown__kqX9S","arrowsDownSmall":"ScrollButton_arrowsDownSmall__fgzJa"};